import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import type { CompsProps } from './Comps';
// import type { EditableTakesProps } from './Takes/EditableTakes';
import type { TakesProps } from './Takes/Takes';

export enum DrawerRenderType {
    none = 'NONE',
    editableTakes = 'EDITABLE_TAKES',
    takes = 'TAKES',
    comps = 'COMPS',
}

type DrawerParams = TakesProps | CompsProps

type RightDrawerState = {
    open: boolean
    render: DrawerRenderType
    params?: DrawerParams
}

const initialState: RightDrawerState = {
    open: false,
    render: DrawerRenderType.none,
    params: undefined,
}

export type DrawerOpenParams =
    { render: DrawerRenderType.takes, params: TakesProps } |
    // { render: DrawerRenderType.editableTakes, params: EditableTakesProps } |
    { render: DrawerRenderType.comps, params: CompsProps }

export const selectDrawerOpen = (state: RootState) => state.rightDrawer.open;
export const selectDrawerRender = (state: RootState) => state.rightDrawer.render;
export const selectRenderParams = (state: RootState) => state.rightDrawer.params;

export const rightDrawerSlice = createSlice({
    name: 'rightDrawer',
    initialState,
    reducers: {
        openDrawer: (state, action: PayloadAction<DrawerOpenParams>) => {
            state.open = true;
            state.render = action.payload.render;
            state.params = action.payload.params;
        },
        closeDrawer: (state) => {
            state.open = false;
            state.render = DrawerRenderType.none;
        },
    },
});

export const {
    openDrawer,
    closeDrawer,
} = rightDrawerSlice.actions;

export default rightDrawerSlice.reducer;